import { useMemo } from 'react';
import { EnhancedAssumptions } from '../types';
import { calculateScenarios } from '../utils';

export const useCalculations = (assumptions: EnhancedAssumptions) => {
  const results = useMemo(() => calculateScenarios(assumptions), [assumptions]);

  const finalYear = results[results.length - 1];
  // Use NET liquidation values (after all exit taxes and costs) for consistent comparison
  const rentAdvantage = finalYear ?
    finalYear.rentScenario.netLiquidationValue - finalYear.sellScenarios.portfolio80_20.netLiquidationValue : 0;

  return {
    results,
    finalYear,
    rentAdvantage
  };
};